import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($stateParams, $http) {
        this.$stateParams = $stateParams;
        this.$http = $http;
    }

    $onInit() {
        this.st = new SmartTable();
        var ctrl = this;
        this.callServer = function callServer(tableState) {
            ctrl.isLoading = true;
            var pagination = tableState.pagination;
            var page = pagination.start / pagination.number;
            var number = pagination.number;

            var searchText = (tableState.search.predicateObject ? tableState.search.predicateObject.searchText : '');
            var sort = tableState.sort.predicate;
            var sortReverse = tableState.sort.reverse;
            if (ctrl.page != page || ctrl.number != number || ctrl.searchText != searchText || ctrl.sort != sort || ctrl.sortReverse != sortReverse) {
                ctrl.page = page;
                ctrl.number = number;
                ctrl.searchText = searchText;
                ctrl.sort = sort;
                ctrl.sortReverse = sortReverse;
                const url = `app/rest/v2/company/${ctrl.$stateParams.companyId}/saaspassadmin/list-all`;
                const params = {page: ctrl.page};
                ctrl.$http.post(url, {page: ctrl.page, itemPerPage: number, searchText, sort, reverse: sortReverse}).then(({data}) => data)
                .then(dto => {
                    pagination.totalItemCount = dto.totalElements;
                    pagination.numberOfPages = dto.totalPages;
                    ctrl.st.displayedItems = dto.content;
                })
                .finally(() => ctrl.isLoading = false);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sp-admin/company-list/company-list.controller.js